import { RestService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { AiTestingSettingsDto, AiTestingSettingsUpdateDto } from './ai-testing-settings.model';
const PATH = '/api/app/ai-testing-settings';

@Injectable({
  providedIn: 'root',
})
export class AiTestingSettingsService {
  apiName = 'Default';

  get = () =>
    this.restService.request<void, AiTestingSettingsDto>(
      {
        method: 'GET',
        url: `${PATH}`,
      },
      { apiName: this.apiName },
    );

  createOrUpdate = (input: AiTestingSettingsUpdateDto) =>
    this.restService.request<AiTestingSettingsUpdateDto, AiTestingSettingsUpdateDto>(
      {
        method: 'PUT',
        url: `${PATH}`,
        body: input,
      },
      { apiName: this.apiName },
    );

  constructor(private restService: RestService) {}
}
